<template>
    <div class="sStatusMapperAction">
        <ValidationObserver ref="form" v-slot="{handleSubmit}">
            <form @submit.prevent="handleSubmit(send)">
                <vs-row>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="internal_status" :name="$t('global.Internal_status')" rules="required" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Internal_status')}}</label>
                                <v-select
                                    ref="select"
                                    :options="options.internal_status"
                                    :reduce="item => item"
                                    name="internal_status"
                                    :clearable="false"
                                    :placeholder="$t('global.Internal_status')"
                                    autocomplete
                                    appendToBody
                                    v-model="params.internal_status"
                                    :calculate-position="withPopper"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="external_status" :name="$t('global.External_status')" rules="required" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.External_status')}}</label>
                                <vs-input
                                    name="external_status"
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.External_status')"
                                    v-model="params.external_status"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="12">
                        <div class="p-2 text-right">
                            <vs-button button="submit" ref="btn">{{ $t('buttons.Save') }}</vs-button>
                        </div>
                    </vs-col>
                </vs-row>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import EventBus from "@/store/eventBus"
import {vSelectPosition} from '@/utils/mixins'

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    mixins: [vSelectPosition],

    data() {
        return {
            options: {
                internal_status: [],
            },
            params: {
                internal_status: '',
                external_status: ''
            }
        }
    },

    components: {
        vSelect
    },

    methods: {
        async send() {
            try {
                let path = this.$url["status-mapping"].create
                let method = 'POST'

                const params = {...this.params}

                Object.keys(params).map(key => {
                    if (!params[key]) delete params[key]
                    if (typeof params[key] === 'string') params[key] = params[key].trim()
                })

                if (this.popupType === 'editStatus') {
                    params.id = this.popupData.id
                    path = this.$url["status-mapping"].update
                    method = 'PATCH'
                }

                await send(path, method, {params})

                EventBus.$emit('updateStatus')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                if(e.response) {
                    const response = e.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        try {
            this.options.internal_status = await send(this.$url["status-mapping"]['group-statuses'], 'GET').then(response => [...new Set(response.data.result)])

            if (this.popupType === 'editStatus') {
                this.params.internal_status = this.popupData.internal_status
                this.params.external_status = this.popupData.external_status
            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>
